import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  PLATFORM_ID,
  provideAppInitializer,
} from "@angular/core";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideRouter } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";
import { routes } from "./app.routes";
import { provideApollo as provideApollo_alias } from "apollo-angular";
import { ApolloLink, DefaultOptions, InMemoryCache } from "@apollo/client/core";
import { HttpLink } from "apollo-angular/http";
import { onError } from "@apollo/client/link/error";
import { authInterceptor } from "./core/auth/auth.interceptor";
import Swal from "sweetalert2";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { providePrimeNG } from "primeng/config";
import Aura from "@primeng/themes/aura";
import { provideServiceWorker } from '@angular/service-worker';
import { MatPaginatorIntl } from "@angular/material/paginator";
import { getCustomPaginatorIntl } from "./core/custom-paginator-intl";
import {
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from "@angular/material/core";
import { registerLocaleData } from "@angular/common";
import localePt from "@angular/common/locales/pt";
import { NgxMaskConfig, provideNgxMask } from "ngx-mask";

import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideTranslateService } from "@ngx-translate/core";
import { environment } from "../environments/environment";
import { TeamsService } from "./core/teams.service";

registerLocaleData(localePt);

const maskConfig: Partial<NgxMaskConfig> = {
  validation: true,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    
    provideServiceWorker(
      'ngsw-worker.js',
      {
        enabled: true,
        registrationStrategy: 'registerWhenStable:30000'

      }
    ),

    HttpLink,
    provideNativeDateAdapter(),
    provideAppInitializer(() => {
      const teamsService = inject(TeamsService);
      return teamsService.init();
    }),
    provideApollo_alias(() => {
      const platformId = inject(PLATFORM_ID);
      const httpLink = inject(HttpLink);

      if (!isPlatformBrowser(platformId)) {
        return {
          cache: new InMemoryCache(),
        };
      }

      const errorLink = onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
          graphQLErrors.forEach(({ message, locations, path }) => {
            // console.error(`[GraphQL Error]: Mensagem: ${message}, Local: ${locations}, Caminho: ${path}`);
            console.log("message");
            console.log(message);
            const elError: any = graphQLErrors[0];
            if (
              elError?.extensions?.originalError?.statusCode === 401 ||
              elError?.extensions?.code === "ACCESS_DENIED"
            ) {
              localStorage.clear();
              window.location.href = "/logout";
            } 
            if(message === "ACCESS_DENIED_REPORT")
            {
                Swal.fire({
                title: "Atenção",
                html: `
                  Você não possui permissão para acessar este relatório.<br><br>
                  Caso necessite do acesso, realize a solicitação através do ServiceNow clicando 
                 <strong> <a href="https://cbmmprod.service-now.com/cbmm" target="_blank">aqui</a></strong>.
                `,
                icon: "warning",
                confirmButtonText: "OK",
              });

            }
            else {
              Swal.fire({
                title: "Atenção",
                html: message,
                icon: "warning",
                confirmButtonText: "OK",
              });
            }
          });
        }
        if (networkError) {
          console.error(`[Network Error]: ${networkError}`);
        }
      });

      const defaultOptions: DefaultOptions = {
        watchQuery: {
          fetchPolicy: "no-cache",
          errorPolicy: "all",
        },
        query: {
          fetchPolicy: "no-cache",
          errorPolicy: "all",
        },
        mutate: {
          fetchPolicy: "no-cache",
          errorPolicy: "all",
        },
      };

      const url = environment.base_graphql;
      return {
        link: ApolloLink.from([errorLink, httpLink.create({ uri: url })]),
        cache: new InMemoryCache(),
        defaultOptions,
      };
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          // darkModeSelector: '.app-dark',
          cssLayer: {
            name: "primeng",
            order: "theme, base, primeng",
          },
        },
      },
    }),
    { provide: MatPaginatorIntl, useValue: getCustomPaginatorIntl() },
    { provide: LOCALE_ID, useValue: "pt-BR" },
    { provide: MAT_DATE_LOCALE, useValue: "pt-BR" },
    provideNgxMask(maskConfig),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: "/i18n/",
        suffix: ".json",
      }),
      fallbackLang: "pt-BR",
      lang: "pt-BR",
    }),
  ],
};
